module.exports = {"id":"201966","name":"Alexander Søderlund","rating":"72","photo":"./data/images/photos/2/201966.png","club":{"name":"Rosenborg BK","logo":"./data/images/clubs/RosenborgBK.png"},"positions":["BU"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlexanderSøderlund0.json
// module id = 240
// module chunks = 0